// extracted by mini-css-extract-plugin
export default {"responsive-stack-root":"ResponsiveStack_responsive-stack-root__LPGGs"};